export const internshipFilterTranslations = {
  lv: {
    button: 'Filtri',
    title: 'Filtrēt prakses',
    clear: 'Notīrīt',
    apply: 'Filtrēt',
    active: 'Aktīvie filtri',
    remove: 'Noņemt filtru “{{filter}}”',
    all: 'Visas',
    classId: 'Specialitāte',
    programId: 'Programma',
    questionGroupId: 'Anketa',
    startFrom: 'Sākums no',
    startTill: 'Sākums līdz',
    endFrom: 'Beigas no',
    endTill: 'Beigas līdz',
  },
  en: {
    button: 'Filters',
    title: 'Filter internships',
    clear: 'Clear',
    apply: 'Apply filters',
    active: 'Active filters',
    remove: 'Remove “{{filter}}” filter',
    all: 'All',
    classId: 'Specialty',
    programId: 'Program',
    questionGroupId: 'Survey',
    startFrom: 'Start from',
    startTill: 'Start till',
    endFrom: 'End from',
    endTill: 'End till',
  },
}
